import { useEffect, useRef } from 'react';
import { PreferenceList } from 'services/api/Meteorology';

type Props = {
  data: any;
  preferenceList: PreferenceList[];
  controlPanelUsed: boolean;

  region?: string;
  selectedModels?: string[];
  period?: string;
  variable?: string;
  anomaly: boolean;
  forecastUnixDate?: number;

  setRegion: (region: string) => void;
  setModelArray: (models: string[]) => void;
  setPeriod: (period: string) => void;
  setVariable: (variable: string) => void;
  setAnomaly: (anomaly: boolean) => void;
  setForecastUnixDate: (value: Date | null) => void;
  requestConsult: () => void;
};

export default function UseSetNumericForecastDefaults({
  data,
  preferenceList,
  controlPanelUsed,

  region,
  selectedModels,
  period,
  variable,
  anomaly,
  forecastUnixDate,

  setRegion,
  setModelArray,
  setPeriod,
  setVariable,
  setAnomaly,
  setForecastUnixDate,
  requestConsult,
}: Props) {
  const didInitRef = useRef(false);

  useEffect(() => {
    // 1. espera carregar preferências
    if (data === undefined) return;

    // 2. roda só uma vez
    if (didInitRef.current) return;

    // 3. se existe preferência salva, não aplica defaults
    if (preferenceList.length > 0) return;

    // 4. se usuário já mexeu, não sobrescreve
    if (controlPanelUsed) return;

    // DEFAULTS DO NEGÓCIO
    const DEFAULT_REGION = 'BR';
    const DEFAULT_MODELS = ['gfs']; // Usando 'gfs' em minúsculo - valor correto do checkbox
    const DEFAULT_PERIOD = 'p+0';
    const DEFAULT_VARIABLE = 'prec';
    const DEFAULT_ANOMALY = false;

    if (!region) setRegion(DEFAULT_REGION);
    if (!period) setPeriod(DEFAULT_PERIOD);
    // IMPORTANTE: setVariable limpa os modelos, então deve ser chamado ANTES de setModelArray
    if (!variable) setVariable(DEFAULT_VARIABLE);
    // Define os modelos APÓS definir a variável para evitar que sejam limpos
    if (!selectedModels || selectedModels.length === 0) {
      setModelArray(DEFAULT_MODELS);
    }
    if (anomaly !== DEFAULT_ANOMALY) setAnomaly(DEFAULT_ANOMALY);

    // setter recebe Date e converte para unix no CP
    if (!forecastUnixDate) {
      setForecastUnixDate(new Date());
    }

    // Abre já consultado: com os defaults completos (GFS/prec/BR/p+0/hoje) a
    // consulta dispara uma vez — espelha o caminho de preferência salva
    // (useLoadFirstPreference). Sem isso o GFS vinha marcado mas sem resultado
    // na tela (reportado pela Bruna na reunião de 15/07).
    requestConsult();

    didInitRef.current = true;
  }, [
    data,
    preferenceList,
    controlPanelUsed,
    region,
    selectedModels,
    period,
    variable,
    anomaly,
    forecastUnixDate,
    setRegion,
    setModelArray,
    setPeriod,
    setVariable,
    setAnomaly,
    setForecastUnixDate,
    requestConsult,
  ]);
}
